import React from "react";
import "../../styles/booking-header.scss";
import logo from "../../assets/dmn_white_logo.svg";
import DmnLogoLink from "../shared/DmnLogoLink";

interface BookingHeaderProps {
  className?: string;
  children?: React.ReactNode;
}

const BookingHeader: React.FC<BookingHeaderProps> = ({ className = "", children }) => {
  return (
    <header
      id="gc-booking-header"
      className={`gc-booking-header booking-header gcw:w-full gcw:opacity-100 gcw:p-6 gcw:lg:mb-6 gcw:mb-0 gcw:bg-dmn-maroon gcw:text-white gcw:text-center gcw:font-bold gcw:text-xl ${className}`}
    >
      <div>
        {/* `block w-fit` keeps the anchor shrink-wrapped and left-aligned, matching
            how the block-level image laid out before it was wrapped in a link.
            An `inline-block` anchor would instead be centred by the header's
            `text-center`, silently moving the logo. */}
        <DmnLogoLink src={logo} className="gcw:block gcw:w-fit" imgClassName="booking-logo gcw:mb-2" />
      </div>
      {children}
    </header>
  );
};

export default BookingHeader;
